import { render, staticRenderFns } from "./RelationshipCardWrapper.vue?vue&type=template&id=597c80d6&"
import script from "./RelationshipCardWrapper.vue?vue&type=script&lang=js&"
export * from "./RelationshipCardWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports